import React from 'react';

const Error = (props) => {
    return (
        <div className="blk blk-result-error"><h4>{props.errormsg}</h4></div>
    )
}

export default Error
